import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import * as fromRoot from '@tv3/store/state'
import { isEmptyTable, localeCompareSort } from '@tokeet-frontend/utility'
import { TableType } from '@tv3/shared/empty-table/table-type'
import {
  ConfirmDialogService,
  Destroyable,
  RateMap,
  Rental,
  RentalService,
  Toaster,
  updateRentalComplete,
} from '@tokeet/tv3-platform'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { AddRateMappingDialogService } from '../../add-rate-mapping-dialog/add-rate-mapping-dialog.service'

@Component({
  selector: 'app-rate-mappings-table',
  templateUrl: './rate-mappings-table.component.html',
  styleUrls: ['./rate-mappings-table.component.scss'],
})
export class RateMappingsTableComponent extends Destroyable implements OnInit, OnChanges {
  @Input() rental: Rental
  @Input() rateMappings: RateMap[] = []
  @Input() connectionId: string

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) sort: MatSort

  displayedColumns = ['rateName', 'category', 'created', 'edit']

  dataSource = new MatTableDataSource<RateMap>()
  isEmptyTable$ = isEmptyTable(this.dataSource)

  constructor(
    private store: Store<fromRoot.State>,
    private toaster: Toaster,
    private confirmDialog: ConfirmDialogService,
    private rentalService: RentalService,
    private addRateMappingDialog: AddRateMappingDialogService
  ) {
    super()
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortData = localeCompareSort
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = this.rateMappings || []
  }

  onAdd() {
    const dialogRef = this.addRateMappingDialog.open({
      rental: this.rental,
      rateMappings: this.dataSource.data,
      connectionId: this.connectionId,
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.rateMappings) {
        this.updateRental(result.rateMappings)
      }
    })
  }

  onDelete(rateMapping: RateMap) {
    this.confirmDialog.confirm().subscribe(() => {
      this.deleteRateMapping(rateMapping)
    })
  }

  private deleteRateMapping(rateMapping: RateMap) {
    this.rentalService
      .deleteRateMapping(this.rental.id, rateMapping.key)
      .pipe(
        tap((rateMappings) => {
          this.toaster.success('Rate mapping deleted successfully.')
          this.updateRental(rateMappings)
        }),
        catchError((error) => {
          this.toaster.error('Unable to delete rate mapping.')
          return of(error)
        })
      )
      .subscribe()
  }

  private updateRental(rateMap: RateMap[]) {
    this.store.dispatch(
      updateRentalComplete({
        update: {
          id: this.rental.id,
          changes: { rateMap },
        },
      })
    )
  }
}
